import React from "react";
import SecuritySection from "./SecuritySection";

const WorldSection = ({
  t,
  language,
  gpsBrands,
  globeStageRef,
  globeWrapRef,
}) => {
  const worldImageSrc =
    language === "en"
      ? `${process.env.PUBLIC_URL}/images/ImagenesWebHome/LiveVideo.png`
      : `${process.env.PUBLIC_URL}/images/ImagenesWebHome/VideoEnVivo.png`;

  return (
    <section className="world-section dark-gradient-section anim-section home-section" id="mundo-gps">
      <div className="home-container world-layout">
        <div className="world-right">
          <div className="world-map-row">
            <div className="globe-stage" ref={globeStageRef}>
              <div className="globe-wrapper anim-world" ref={globeWrapRef}>
                <img
                  className="globe-image"
                  src={worldImageSrc}
                  alt={language === "en" ? "Live video" : "Video en vivo"}
                  loading="lazy"
                />
              </div>
            </div>
            <div className="gps-animated-text anim-world-copy">
              <span className="gps-kicker">{t.world.kicker}</span>
              <h3>{t.world.title}</h3>
              <p>{t.world.copy}</p>
              <ul className="gps-pill-row">
                {t.world.pills.map((pill) => (
                  <li key={pill}>{pill}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <SecuritySection t={t} />
    </section>
  );
};

export default WorldSection;
